var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChipArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95083 4.23683L6.18763 8.00014L9.95083 11.7635L9.14272 12.5716L4.57129 8.00014L9.14272 3.42871L9.95083 4.23683Z",
    fill: "#203662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58874 16 0 12.4113 0 8C0 3.58874 3.58874 0 8 0C12.4113 0 16 3.58874 16 8C16 12.4113 12.4113 16 8 16ZM8 1.14286C4.21903 1.14286 1.14286 4.21903 1.14286 8C1.14286 11.781 4.21903 14.8571 8 14.8571C11.781 14.8571 14.8571 11.781 14.8571 8C14.8571 4.21903 11.781 1.14286 8 1.14286Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipArrowLeft);
export default __webpack_public_path__ + "static/media/chip-arrow-left.797294ac3507ce16b7f7a0208886ea5c.svg";
export { ForwardRef as ReactComponent };